var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselCar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "pgu04zcgma"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#pgu04zcgma"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(3 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E3DD",
    d: "m36.511 45.555-.464-.294.006-2.695.734.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "m36.493 42.623.008 2.702v.224l17.37-9.85.013-2.764"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDDAD7",
    d: "m36.012 42.556.46.291L54 32.966l-.414-.218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5C662",
    d: "M36.049 37.945v7.318L.229 25.014l-.115-.09-.114-.09.04-7.734"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7CF81",
    d: "m39.55 11.422 3.993 9.047 8.546 5.505 1.487 2.61-17.558 9.517L.068 17.204v-2.051l2.67-5.224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE09B",
    d: "M39.578 11.455 22.12 21.48 2.732 9.84 20.068 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB70",
    d: "M36.04 38.088v4.486l17.567-9.82V28.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DBBC7",
    d: "m50.271 31.379-.043 2.514-10.408 5.799.043-2.506M47.095 37.402v1.412l-2.629 1.52v-1.446"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEBC1E",
    d: "M38.614 43.055v.935l-1.74 1.006V44.04M53.662 34.59v.935l-1.74 1.005V35.572"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-56.78 37.704 39.504)",
    cx: 37.704,
    cy: 39.504,
    rx: 1.411,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-56.78 51.94 31.722)",
    cx: 51.94,
    cy: 31.722,
    rx: 1.411,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.686 41.75c.307-1.312.057-2.969-.8-4.508-1.454-2.62-4.105-3.908-5.922-2.88-.889.503-1.415 1.467-1.547 2.627",
    fill: "#9B886F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#080405",
    d: "m23.726 34.754 1.265-.588-.758.59-.577.029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.553 44.422 3.017-1.673-1.234-.69a7.203 7.203 0 0 0-.21-1.852c-.17-.677-.39-1.138-.65-1.68a11.243 11.243 0 0 0-1.274-2.075 12.28 12.28 0 0 0-.915-1.013 5.47 5.47 0 0 0-.65-.59 4.244 4.244 0 0 0-.495-.33 6.643 6.643 0 0 0-.554-.261 1.806 1.806 0 0 0-.503-.093l-.094.001c-.004 0-.008 0-.014.004-.145.045-1.003.529-1.003.529",
    fill: "#080405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.702 43.725c1.463-.828 1.408-3.76-.067-6.414-1.402-2.522-3.56-3.823-4.872-3.024",
    fill: "#080405"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#363A45",
    transform: "rotate(-29.27 25.903 39.687)",
    cx: 25.903,
    cy: 39.687,
    rx: 3.214,
    ry: 5.422
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F7",
    transform: "rotate(-29.32 25.778 39.69)",
    cx: 25.778,
    cy: 39.691,
    rx: 2.326,
    ry: 3.963
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8DBBC7",
    transform: "rotate(-29.55 25.763 39.663)",
    cx: 25.763,
    cy: 39.664,
    rx: 1.121,
    ry: 1.758
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.386 30.817c.307-1.311.057-2.968-.8-4.508-1.454-2.619-4.105-3.908-5.922-2.88-.889.504-1.415 1.468-1.547 2.627",
    fill: "#9B886F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.253 33.49 3.017-1.674-1.234-.69a7.203 7.203 0 0 0-.21-1.852c-.17-.677-.39-1.137-.65-1.68a11.243 11.243 0 0 0-1.274-2.074 12.28 12.28 0 0 0-.915-1.014 5.47 5.47 0 0 0-.65-.59 4.244 4.244 0 0 0-.495-.329 6.643 6.643 0 0 0-.554-.261 1.806 1.806 0 0 0-.503-.093H5.69c-.004 0-.008 0-.014.005-.145.045-1.003.528-1.003.528",
    fill: "#080405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.402 32.79c1.463-.828 1.408-3.759-.067-6.413-1.402-2.522-3.56-3.824-4.872-3.024",
    fill: "#080405"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#363A45",
    transform: "rotate(-29.27 6.604 28.755)",
    cx: 6.604,
    cy: 28.755,
    rx: 3.214,
    ry: 5.422
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F7F7F7",
    transform: "rotate(-29.32 6.479 28.757)",
    cx: 6.479,
    cy: 28.757,
    rx: 2.326,
    ry: 3.963
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8DBBC7",
    transform: "rotate(-29.55 6.463 28.73)",
    cx: 6.463,
    cy: 28.73,
    rx: 1.121,
    ry: 1.758
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444A36",
    strokeWidth: 0.114,
    fill: "#444A36",
    d: "m39.005 13.14 3.562 7.446-15.824 8.891-3.56-7.553M16.53 19.62l4.793 2.781 3.69 7.658-8.474-4.8zM15.543 18.995v5.653L8.94 20.946l1.934-4.607M10.119 15.767l-1.98 4.63-6.5-3.776 2.082-4.486"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-car.7f9086f8dbc7cbf88e7f39465b6e8033.svg";